<!-- History Void Pays/Payments -->
<div ngbAccordion class="payrollAccordion" *ngIf="historyVoids?.length">
  <div
    ngbAccordionItem
    ngbAccordionItem="histVoidReport"
    #histVoidReport="ngbAccordionItem"
    [collapsed]="true">
    <h2 ngbAccordionHeader [title]="histVoidReport.collapsed ? 'Click to View' : 'Click to Hide'">
      <button ngbAccordionButton>
        <h4>History Void Pays/Payments</h4>
      </button>
    </h2>
    <div ngbAccordionCollapse>
      <div ngbAccordionBody>
        <ng-template>
          <h6>Client Services: {{ reportTitle }}</h6>
          <h6>Pays Voided</h6>
          <table class="table table-borderless">
            <thead>
              <tr>
                <td>ID</td>
                <td>Pay Date</td>
                <td>Payee</td>
                <td>Method</td>
                <td>Amount</td>
                <td>Check/Voucher #</td>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let v of historyVoids">
                <td>{{ v.EmployeeId }}</td>
                <td>{{ v.PayDate | date: 'MM/dd/yyyy' }}</td>
                <td>{{ v.EmployeeName }}</td>
                <td>{{ v.Method }}</td>
                <td>{{ v.Amount | currency }}</td>
                <td>{{ v.CheckNo }}</td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="thirdPartyReport?.length" class="mt-5">
            <h6>Third Party Disbursements</h6>
            <table class="table table-borderless">
              <thead>
                <tr>
                  <td>ID</td>
                  <td>Pay Date</td>
                  <td>Name</td>
                  <td>Payee</td>
                  <td>Method</td>
                  <td>Amount</td>
                  <td>Deduction</td>
                  <!-- <td>Combined Payment</td> -->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let t of thirdPartyReport">
                  <td>{{ t.EmployeeId }}</td>
                  <td>{{ t.PayDate | date: 'MM/dd/yyyy' }}</td>
                  <td>{{ t.EmployeeName }}</td>
                  <td>{{ t.Payee }}</td>
                  <td>{{ t.Method }}</td>
                  <td>{{ t.Amount | currency }}</td>
                  <td>{{ t.Deduction }}</td>
                  <!-- <td>{{t.Combined}}</td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
